



































































































































import Vue from "vue";
import { axios } from "../../plugins";
import { Header } from "../MyTabs.vue";
import { Header as TableHeader } from "@/components/MyTable.vue";
import { uuid } from "../../utils/uuid";

const Tab: Header[] = [
  {
    label: "概览",
    name: "tab1",
    uuid: uuid()
  }
];

const PortHeader: TableHeader[] = [
  { title: "名称", key: "name" },
  { title: "协议", key: "protocol" },
  { title: "服务端口", key: "targetPort" },
  { title: "容器端口", key: "port" }
];
const ContainerHeader: TableHeader[] = [
  { title: "名称", key: "", width: 300 },
  { title: "服务端口", key: "", width: 100 },
  { title: "容器端口", key: "", width: 100 },
  { title: "状态", key: "", width: 100 },
  { title: "主机", key: "", width: 200 },
  { title: "容器组IP", key: "", width: 100 }
];
export default Vue.extend({
  name: "ServiceInfo",
  props: { projectId: { type: String } },
  data() {
    return {
      dialog: false,
      serviceData: null as any,
      Tab,
      tabActive: "tab1",
      PortHeader,
      ContainerHeader,
      containers: [] as any[]
    };
  },
  computed: {
    tagColor() {
      return "";
    },
    tagValue() {
      return "";
    }
  },
  methods: {
    getServiceInfo(name: string) {
      return axios.get(`/service/${this.projectId}/${name}`).then(res => {
        this.serviceData = res.data.data;
        return this.getContainers(name);
      });
    },
    getContainers(name: string) {
      return axios
        .get(
          `/pod/container/svc/list/project?projectId=${this.projectId}&svcName=${name}`
        )
        .then(res => {
          this.containers = res.data.data;
        });
    },
    show(data: any) {
      // 显示之前先调用接口，添加loading无法显示，所以这页不添加loading
      this.getServiceInfo(data.metadata.name).then(() => {
        this.dialog = true;
      });
    },
    close() {
      this.dialog = false;
    },
    findContainer(port: number) {
      return (
        (this.serviceData.spec.ports as any[]).find(
          item => item.targetPort === port
        ) || {}
      );
    }
  }
});
